import React from 'react';
import './style.scss';

export default function TopBanner() {
    return (
        <section className="top-banner">
            <h1 className="desktop">
                <i className="fiverr-pro-logo"/>
                {i18n.t('pro_homepage.top_banner.title_1')}<br/>
                {i18n.t('pro_homepage.top_banner.title_2')}<br/>
                {i18n.t('pro_homepage.top_banner.title_3')}
            </h1>
            <h1 className="mobile">
                <i className="fiverr-pro-logo"/>
                {i18n.t('pro_homepage.top_banner.title_1')}
                {i18n.t('pro_homepage.top_banner.title_2')}
                {i18n.t('pro_homepage.top_banner.title_3')}
            </h1>
        </section>
    );
}



// WEBPACK FOOTER //
// ./src/common/HomePage/TopBanner/index.js